import { DataWidgetBase } from '../../widgets/models';
import { MapWidgetDefinition as definition } from './map.definition';
import { Helper } from '../../common';
import { liege } from './liege';
import { MapWidgetConfiguration } from './MapWidgetConfiguration';
import { WidgetValuesReadConfiguration } from '../../models';
import { IwidgetIntervalHelperService } from '../../services/helpers';
import { AggregationConfiguration } from '../../models/aggregationConfiguration';
import { AggregationMode } from '../../models/enum';
import { IPeriodConfiguration } from '../../models/IPeriodConfiguration';

export class MapWidget extends DataWidgetBase {
    sizeX = 12;
    sizeY = 36;
    col = 0;
    row = 0;
    name = definition.title;
    type = definition.type;
    baseType = definition.baseType;
    guid: string;
    highlights = definition.highlights;
    icon = definition.icon;
    configuration: MapWidgetConfiguration = {
        center: { ...liege },
        showGroups: true,
        showTags: false,
        showAlarms: true
    };
    hasExtendedProperties = false;

    private _noneAggregation: AggregationConfiguration = { period: null, mode: AggregationMode.None };

    constructor(intervalHelper: IwidgetIntervalHelperService) {
        super(intervalHelper);
        this.guid = Helper.getGuid();
        this.name = definition.title;
        this.configuration = { ...this.configuration, ...{ series: [] } };
    }

    getReadConfiguration(beginDate: string, endDate: string): WidgetValuesReadConfiguration {
        return this.getReadConfigurationBase(
            beginDate,
            endDate,
            this.configuration.series,
            {} as IPeriodConfiguration,
            this._noneAggregation,
            false,
            false,
            false,
            false,
            false,
            undefined,
            this.configuration.showAlarms
        );
    }
}
